// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bih_ss","PhotoTitleEditForm__cancelBtn":"iy_b bih_sw bih_sv"};